import * as firebase from 'firebase';

// var firebaseConfig = {
//   apiKey: 'AIzaSyD-jnNFP4MtQjzhROzGyGb--_vM5WbfdUA',
//   authDomain: 'tn-edu.firebaseapp.com',
//   projectId: 'tn-edu',
//   storageBucket: 'tn-edu.appspot.com',
//   messagingSenderId: '117151481797',
//   appId: '1:117151481797:web:f17ba8b4fab9be6ee415ac',
//   measurementId: 'G-PDLLDCPBF9',
// };

const firebaseConfig = {
  apiKey: 'AIzaSyCnNv3aJ20QNd4QZcf4cjzm8hqoKpVZ89c',
  authDomain: 'tn-edu-dev.firebaseapp.com',
  projectId: 'tn-edu-dev',
  storageBucket: 'tn-edu-dev.appspot.com',  
  messagingSenderId: '702740602366',
  appId: '1:702740602366:web:1c8dd24a1e308a9fcab4af',
};

// const firebaseConfig = {
//   apiKey: "AIzaSyD8MiNmNRYBHFTxWwS933WMKbyLdAfKZk0",
//   authDomain: "tnedu-v2.firebaseapp.com",
//   projectId: "tnedu-v2",
//   storageBucket: "tnedu-v2.appspot.com",
//   messagingSenderId: "943463433735",
//   appId: "1:943463433735:web:3ab3a4b1524b4d4bc30ca2",
//   measurementId: "G-MXH97H0803"
// };

const firebaseApp = firebase.initializeApp(firebaseConfig);
 const firestore = firebase.firestore();
const db = firebaseApp.firestore();
const auth = firebase.auth();
const storage = firebase.storage();

export { db, auth, storage, firestore };
